import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import { isDate, intervalToDuration, format } from 'date-fns';
import * as React from 'react';
import styled from 'styled-components';
import { useThemeContext } from '../../styles/themes/themes.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["date"];
var DateContainer = styled.div.withConfig({
  displayName: "Timestamp__DateContainer",
  componentId: "pptg90-0"
})(["&&{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:42px;}"]);
var Timestamp = /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef(function Timestamp2(props, ref) {
  var date = props.date,
      rest = _objectWithoutProperties(props, _excluded);

  var _useThemeContext = useThemeContext(),
      i18n = _useThemeContext.i18n;

  var invalidDate = i18n.Timestamp.invalidDate;

  var startDate = function () {
    if (isDate(date)) {
      return date;
    } else {
      if (isNaN(Date.parse(date))) {
        if (process.env.NODE_ENV !== "production") {
          console.error("ERROR: Unable to create Date from given date: '".concat(date, "'"));
        }

        return void 0;
      }

      return new Date(date);
    }
  }();

  var timestamp = startDate && intervalToDuration({
    start: startDate,
    end: new Date()
  });

  var getTooltipContent = function getTooltipContent() {
    if (!timestamp || !startDate) return void 0;
    return timestamp.years && timestamp.years > 0 ? "".concat(format(startDate, "MMM d',' y 'at' h:mm aaaaa'm'")) : "".concat(format(startDate, "MMM d 'at' h:mm aaaaa'm'"));
  };

  var getFormattedDate = function getFormattedDate() {
    var dateFormatted;
    if (!startDate || !timestamp) return invalidDate;

    switch (true) {
      case timestamp.years && timestamp.years > 0:
        dateFormatted = "".concat(format(startDate, "MMM d',' y 'at' h:mm aaaaa'm'"));
        break;

      case timestamp.months && timestamp.months > 0 || timestamp.days && timestamp.days > 1:
        dateFormatted = "".concat(format(startDate, "MMM d 'at' h:mm aaaaa'm'"));
        break;

      case timestamp.days && timestamp.days === 1:
        dateFormatted = "Yesterday at ".concat(format(startDate, "h:mm aaaaa'm'"));
        break;

      case timestamp.hours && timestamp.hours > 0:
        dateFormatted = "".concat(timestamp.hours, " ").concat(timestamp.hours === 1 ? "hour" : "hours", " ago");
        break;

      case timestamp.minutes && timestamp.minutes > 0:
        dateFormatted = "".concat(timestamp.minutes, " ").concat(timestamp.minutes === 1 ? "minute" : "minutes", " ago");
        break;

      case timestamp.seconds && timestamp.seconds > 0:
        dateFormatted = "A few seconds ago";
        break;

      default:
        if (process.env.NODE_ENV !== "production") {
          console.error("ERROR: Unable to format the date given: '".concat(startDate, "'"));
        }

        dateFormatted = invalidDate;
    }

    return dateFormatted;
  };

  return /*#__PURE__*/jsx(DateContainer, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: /*#__PURE__*/jsx(Tooltip, {
      content: getTooltipContent(),
      children: /*#__PURE__*/jsx("span", {
        children: getFormattedDate()
      })
    })
  }));
}));
Timestamp.displayName = "Timestamp";

export { Timestamp };
